import { ProgramFunding } from "./program-funding";
export class ProgramDetails {
    public id: number;
    public description: string;
    public setting: number;
    public settingOther: string;
    public numberServed: number;
    public numberFullTimeStaff: number;
    public numberPartTimeStaff: number;
    public numberStafffWithDegree: number;
    public programLicensing: number;
    public funding: ProgramFunding;
    public eligibilityForEnrollment: string;
    public nonProfit: boolean;
    public militaryFamilies: boolean;
    public usesACTNowQualityStandards: boolean;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-details.ts